<div class="listview-header mt-0">
  <div class="row flex-nowrap">
    <div class="col-3">
      <base-checkbox
        *ngIf="!isWorkCouncil"
        [isChecked]="allSelected"
        [isDisabled]="isListEmpty"
        (getChange)="onAllSelected($event)"
        label="name"
        [tooltip]="(allSelected ? 'inquiry.deselectAll' : 'inquiry.selectAll') | translate"
        checkboxClasses="checkbox-shadow"
      ></base-checkbox>
      <span *ngIf="isWorkCouncil">{{ 'name' | translate }}</span>
    </div>
    <div
      class="col"
      baseTruncate
    >
      {{ 'provider' | translate }}
    </div>
    <div
      class="col-2"
      baseTruncate
    >
      {{ 'externalEmployees.departmentAndLocation' | translate }}
    </div>
    <div class="col">
      <base-sortable-headline-item
        label="operations.singular"
        [orderKey]="orderKeys.startDate"
      ></base-sortable-headline-item>
    </div>
    <div
      class="col-1"
      baseTruncate
    >
      <base-sortable-headline-item
        label="mlpShort"
        orderKey="mlp"
      ></base-sortable-headline-item>
    </div>
    <div
      class="col-1"
      baseTruncate
    >
      <base-sortable-headline-item
        label="epShort"
        orderKey="ep"
      ></base-sortable-headline-item>
    </div>
    <div
      class="col-1"
      baseTruncate
    >
      <base-sortable-headline-item
        label="operations.agreedWorkingTime.short"
        orderKey="weeklyWorkingHours"
      ></base-sortable-headline-item>
    </div>
    <div class="col"></div>
  </div>
</div>
